import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
// let btnList = ['add']
import store from '@/store/index';
export function hasBtnPermiss(authName) {
  // console.log('$btnList',store.state.custom.permission.btnList);
  var btnList = store.state.custom.permission.btnListObj; // const arr = []

  var obj = {
    isShow: false,
    Menu_Code: null,
    Menu_Name: null
  }; // console.log('123',(btnList.filter(item=>item.Menu_Code.includes('DnbarcodeHandmade'))).map(item=>item.Menu_Code));

  var filter = btnList.filter(function (item) {
    return item.Menu_Code === authName;
  }); // console.log('filter',filter);

  filter.forEach(function (v) {
    if (v.ENABLED === "Y") {
      obj.isShow = true;
      obj.Menu_Code = v.Menu_Code;
      obj.Menu_Name = v.Menu_Name;
    }
  });
  return obj;
}